import { Resource as a, API as e } from "@coveo/platform-client";
const t = class t extends a {
  startJob(r) {
    return this.api.post(`${t.baseUrl}`, r);
  }
  getJobStatus(r) {
    return this.api.get(`${t.baseUrl}/${r}/status`);
  }
  getChunks(r) {
    return this.api.get(`${t.baseUrl}/${r}/result`);
  }
};
t.baseUrl = `/rest/organizations/${e.orgPlaceholder}/chunkinspector/answerquery/v1/chunkretrievaljobs`;
let s = t;
export {
  s as ChunkInspectorAnswerResource
};
//# sourceMappingURL=ChunkInspectorAnswer.js.map
